export enum PathPickerType {
  FILE,
  FOLDER,
  ALL,
}
